import { isNavigationFailure } from 'vue-router'
import { useRouteStoreWithOut } from '@/stores/modules/route'
import { useUserStoreWidthOut } from '@/stores/modules/user'
import { ACCESS_TOKEN } from '@/stores/mutation-types'
import { storage } from '@/utils/storageUtils'
import { isHeaderNavBar } from '@/utils/isUtils'
import { PageEnum } from '@/enums/pageEnum'
import { LoginStateEnum } from '@/enums/loginEnum'
import { loginState, loginStateMatchList } from '@/settings/loginSetting'
import { showDialog } from 'vant'
import { versionCheckUpdate } from '@/plugins/versionCheckUpdate'
import homeApi from '@/api/system/home'

// 身份凭证在入口处消费并写入本地存储后，需要从地址栏移除，
// 避免复制或分享链接时泄露用户信息。
const SENSITIVE_QUERY_KEYS = ['userId', 'token', 'tenantId']

const whitePathList = [] // 无重定向白名单

/**
 * 脚手架可能面临3种情况，
 * 1是有登录页面、
 * 2是没有登录页面，但是需要拿到token才能展示，
 * 3是既没有登录也不需要token就可以显示全部页面
 */
for (const item of loginStateMatchList) {
  if (loginState === item.state) {
    whitePathList.push(item.target)
  }
}

export function createRouterGuards(router) {
  router.beforeEach((to, from, next) => {
    // to: 即将要进入的目标
    // from: 当前导航正要离开的路由
    // console.log('==: ', to.path, from.path)
    const query = to.query ?? {}
    if (query.token) {
      localStorage.removeItem('token')
      localStorage.setItem('token', query.token)
    }
    if (query.tenantName) {
      localStorage.setItem('tenantName', query.tenantName)
    }
    if (query.channel) {
      localStorage.removeItem('channel')
      localStorage.setItem('channel', query.channel)
    }
    if (query.userId) {
      localStorage.removeItem('userId')
      localStorage.setItem('userId', query.userId)
    }
    if (query.tenantId) {
      localStorage.removeItem('tenantId')
      localStorage.setItem('tenantId', query.tenantId)
    }
    if (query.saasCompanyId) {
      localStorage.removeItem('saasCompanyId')
      localStorage.setItem('saasCompanyId', query.saasCompanyId)
    }

    // 敏感参数已经落盘，使用 replace 导航清理当前历史记录。
    // 非敏感 query、path 和 hash 保持不变；return 避免本次导航继续执行鉴权逻辑。
    const hasSensitiveQuery = SENSITIVE_QUERY_KEYS.some((key) =>
      Object.prototype.hasOwnProperty.call(query, key)
    )
    if (hasSensitiveQuery) {
      const sanitizedQuery = {}
      for (const key in query) {
        if (!SENSITIVE_QUERY_KEYS.includes(key)) {
          sanitizedQuery[key] = query[key]
        }
      }
      next({ path: to.path, query: sanitizedQuery, hash: to.hash, replace: true })
      return
    }

    // 悦享福利AppId: yxfl
    // sassAppId: saas
    // 叩我AppId: callMe
    const channel = query?.channel || localStorage.getItem('channel')
    const userId = query?.userId || localStorage.getItem('userId')

    if (channel == 'callMe') {
      const data = {
        userId: userId
      }
      homeApi.getToken(data, channel).then((res) => {
        console.log(res, 'res')
        localStorage.setItem('token', res.data)
        next()
      })
    } else {
      next()
    }
  })

  // 进入某个路由之后触发的钩子
  router.afterEach((to, _, failure) => {
    // 设置每个页面的 title
    if(to.meta.showHeaderNavBar && isHeaderNavBar()){
      document.title = localStorage.getItem("tenantName")||""
    }else{
      document.title = to?.meta?.title || document.title
    }
    
    // console.log('==? ', to.path, _.path)
    if (isNavigationFailure(failure)) {
      console.log('failed navigation', failure)
    }

    const routeStore = useRouteStoreWithOut()
    // 在这里设置需要缓存的组件名称
    const keepAliveComponents = routeStore.keepAliveComponents
    // 获取当前组件名
    const currentComName = to.matched.find((item) => item.name == to.name)?.name

    // 缓存该组件的条件
    if (currentComName && !keepAliveComponents.includes(currentComName) && to.meta?.keepAlive) {
      // 需要缓存的组件
      keepAliveComponents.push(currentComName)
      // keepAlive 为 false 则不缓存
    } else if (!to.meta?.keepAlive) {
      // 不需要缓存的组件

      // 这里的作用一开始组件设置为缓存，之后又设置不缓存但是它还是存在 keepAliveComponents 数组中
      // keepAliveComponents 使用 findIndex 与 当前路由对比，如果存在则返回具体下标位置，不存在返回 -1
      const index = routeStore.keepAliveComponents.findIndex((name) => name == currentComName)
      if (index != -1) {
        // 通过返回具体下标位置删除 keepAliveComponents 数组中缓存的 元素
        keepAliveComponents.splice(index, 1)
      }
    }
    routeStore.setKeepAliveComponents(keepAliveComponents)
  })

  router.onError((error) => {
    console.error(error, '路由错误')
    versionCheckUpdate()
  })
}
